module.exports = __webpack_public_path__ + "static/media/1-solution-0.e6e4c268.mp3";